import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { Helpers } from 'src/app/app.helpers';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class LogsComponent implements OnInit {
  hasApiError = false;
  apiError: string;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [
    'id',
    'associated_job_id',
    'creation_date',
    'node',
    'level',
    'service',
    'code',
    'message',
    'actions'];

  constructor(
    private api: ApiService,
    private configFactory: AuthClientConfig,
    public helpers: Helpers

  ) { }

  ngOnInit(): void {
    this.getLogs()
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  getLogs() {
    this.api.getLogs$().subscribe({
      next: (res) => {
        this.hasApiError = false;
        this.dataSource = new MatTableDataSource<any>(res);
        this.dataSource.paginator = this.paginator;
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }

  deleteLog(id: string) {
    this.api.deleteLogssId$(id).subscribe({
      next: () => {
        this.hasApiError = false;
        this.getLogs()
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }
}
